import React from 'react';
import { Steps } from 'antd';
import PropTypes from 'prop-types';

const { Step } = Steps;

const ProjectApplicationStep = ({ current }) => {
  return (
    <Steps current={current}>
      <Step title="General Information" />
      <Step title="Submit for Endorsement" />
      <Step title="Endorsement" />
      <Step title="Application Received" />
    </Steps>
  );
};

ProjectApplicationStep.propTypes = {
  current: PropTypes.number,
};

export default ProjectApplicationStep;
